/* eslint-disable */
import moment from 'moment';
// connection status
const status = {
    Pending : "pending",
    Connected: "connected"
}
export const EditEnrollDisableCheck = (pateintEnrollOverview, patient) => {
    let disableCheck = true
//   console.log('patient detail', patient);
const todayDate = moment().format("DD-MM-YYYY")
// console.log("today date", moment().format("DD-MM-YYYY"));
// console.log("moment()", moment( moment().format("DD-MM-YYYY"), "DD-MM-YYYY").add(20, 'days').format("DD-MM-YYYY"));
// console.log("date check", moment(todayDate).isAfter(moment( moment().format("DD-MM-YYYY"), "DD-MM-YYYY").add(20, 'days').format("DD-MM-YYYY")));
  // Check if has_active_enrollment
if(pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data.has_active_enrollment) { //has_active_enrollment true
    console.log("has_active_enrollment true");
    if(pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data && pateintEnrollOverview.data.latest_enrollment){
        console.log("latest_enrollment true");
        // if // -- Check has_active_enrollment - true, latest_enrollment.is_active - true, connection_code_redeemed_at is having date ----> Button Disable
        if(pateintEnrollOverview.data.latest_enrollment && pateintEnrollOverview.data.latest_enrollment.is_active && pateintEnrollOverview.data.latest_enrollment.connection_code_redeemed_at){
            // Button disable
            // return true
            disableCheck = true
        }
        // need to discuss both case
        // if // now also check --- > Today's Date > (study_period_starts_at + duration) is less then ---> Means Study day is over - connection is done -------> Button Enable  else Disable
        if(pateintEnrollOverview.data.latest_enrollment.study_period_starts_at){
            if(moment(todayDate).isAfter(moment(moment(pateintEnrollOverview.data.latest_enrollment.study_period_starts_at).format("DD-MM-YYYY"), "DD-MM-YYYY").add(pateintEnrollOverview.data.latest_enrollment.duration, 'days').format("DD-MM-YYYY"))){
                // Button Enable
                // return false
                disableCheck = false
            } else {
                // Button disable
            // return true
            disableCheck = true
            }
        }
    } else {
     // Will never have this condition
      //return true
      disableCheck = true
    }
  } else {
    // has_active_enrollment false
    if(pateintEnrollOverview && pateintEnrollOverview.data && pateintEnrollOverview.data && pateintEnrollOverview.data.latest_enrollment){
      // ----- check latest_enrollment connection is over
      // Today's Date > (study_period_starts_at + duration)
      if(moment(todayDate).isAfter(moment(moment(pateintEnrollOverview.data.latest_enrollment.study_period_starts_at).format("DD-MM-YYYY"), "DD-MM-YYYY").add(pateintEnrollOverview.data.latest_enrollment.duration, 'days').format("DD-MM-YYYY"))){
        // Button Enable
        //return false
        disableCheck = false
        } else {
            // Button disable
        // return true
        disableCheck = true
        }
    } else {
      if(patient.connectionStatus === status.Pending ){
        // return false
        disableCheck = false
        // Button Enable
      } else if(patient.connectionStatus === status.Connected){
        // Button disable
        // return true
        disableCheck = true
      }
    }
  }
  return disableCheck
}


// WEBPACK FOOTER //
// ./src/legacy/pages/PatientFile/util.js